import React, { useEffect, useState, useCallback } from 'react';
import { Form, Row, Col, Typography, Flex, Button, Input, Spin, Result, message } from 'antd';
import moment from 'moment-timezone';
import { useParams } from 'react-router-dom';
import { PiArrowArcRightDuotone, PiCalendarCheckDuotone, PiDeviceMobileSpeakerFill, PiGoogleChromeLogoDuotone, PiMapPinAreaDuotone, PiPhoneCallDuotone, PiSealCheckDuotone } from 'react-icons/pi';
import { LoadingOutlined } from '@ant-design/icons';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
const { Paragraph, Title } = Typography;

const formatDate = (date) => {
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    const daySuffix = (day) => {
        if (day > 3 && day < 21) return 'th';
        switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
        }
    };
    return `${day}${daySuffix(day)} ${month} ${year}`;
};


const currencyToCountryMap = {
    AED: 'ae',
    AFN: 'af',
    ALL: 'al',
    AMD: 'am',
    ANG: 'cw',
    AOA: 'ao',
    ARS: 'ar',
    AUD: 'au',
    AWG: 'aw',
    AZN: 'az',
    BAM: 'ba',
    BBD: 'bb',
    BDT: 'bd',
    BGN: 'bg',
    BHD: 'bh',
    BIF: 'bi',
    BMD: 'bm',
    BND: 'bn',
    BOB: 'bo',
    BRL: 'br',
    BSD: 'bs',
    BTN: 'bt',
    BWP: 'bw',
    BYN: 'by',
    BZD: 'bz',
    CAD: 'ca',
    CDF: 'cd',
    CHF: 'ch',
    CLP: 'cl',
    CNY: 'cn',
    COP: 'co',
    CRC: 'cr',
    CUP: 'cu',
    CVE: 'cv',
    CZK: 'cz',
    DJF: 'dj',
    DKK: 'dk',
    DOP: 'do',
    DZD: 'dz',
    EGP: 'eg',
    ERN: 'er',
    ETB: 'et',
    EUR: 'eu',
    FJD: 'fj',
    FKP: 'fk',
    FOK: 'fo',
    GBP: 'gb',
    GEL: 'ge',
    GHS: 'gh',
    GIP: 'gi',
    GMD: 'gm',
    GNF: 'gn',
    GTQ: 'gt',
    GYD: 'gy',
    HKD: 'hk',
    HNL: 'hn',
    HRK: 'hr',
    HTG: 'ht',
    HUF: 'hu',
    IDR: 'id',
    ILS: 'il',
    INR: 'in',
    IQD: 'iq',
    IRR: 'ir',
    ISK: 'is',
    JMD: 'jm',
    JOD: 'jo',
    JPY: 'jp',
    KES: 'ke',
    KGS: 'kg',
    KHR: 'kh',
    KMF: 'km',
    KPW: 'kp',
    KRW: 'kr',
    KWD: 'kw',
    KYD: 'ky',
    KZT: 'kz',
    LAK: 'la',
    LBP: 'lb',
    LKR: 'lk',
    LRD: 'lr',
    LSL: 'ls',
    LYD: 'ly',
    MAD: 'ma',
    MDL: 'md',
    MGA: 'mg',
    MKD: 'mk',
    MMK: 'mm',
    MNT: 'mn',
    MOP: 'mo',
    MRU: 'mr',
    MUR: 'mu',
    MVR: 'mv',
    MWK: 'mw',
    MXN: 'mx',
    MYR: 'my',
    MZN: 'mz',
    NAD: 'na',
    NGN: 'ng',
    NIO: 'ni',
    NOK: 'no',
    NPR: 'np',
    NZD: 'nz',
    OMR: 'om',
    PAB: 'pa',
    PEN: 'pe',
    PGK: 'pg',
    PHP: 'ph',
    PKR: 'pk',
    PLN: 'pl',
    PYG: 'py',
    QAR: 'qa',
    RON: 'ro',
    RSD: 'rs',
    RUB: 'ru',
    RWF: 'rw',
    SAR: 'sa',
    SBD: 'sb',
    SCR: 'sc',
    SDG: 'sd',
    SEK: 'se',
    SGD: 'sg',
    SHP: 'sh',
    SLL: 'sl',
    SOS: 'so',
    SRD: 'sr',
    SSP: 'ss',
    STN: 'st',
    SYP: 'sy',
    SZL: 'sz',
    THB: 'th',
    TJS: 'tj',
    TMT: 'tm',
    TND: 'tn',
    TOP: 'to',
    TRY: 'tr',
    TTD: 'tt',
    TWD: 'tw',
    TZS: 'tz',
    UAH: 'ua',
    UGX: 'ug',
    USD: 'us',
    UYU: 'uy',
    UZS: 'uz',
    VES: 've',
    VND: 'vn',
    VUV: 'vu',
    WST: 'ws',
    XAF: 'cm',
    XCD: 'ag',
    XOF: 'sn',
    XPF: 'pf',
    YER: 'ye',
    ZAR: 'za',
    ZMW: 'zm',
    ZWL: 'zw',
};

const QrCodeContent = () => {

    const { qrId } = useParams();
    const [qrData, setQrData] = useState({});
    const [secondStapPageType, setSecondStapPageType] = useState('landing');
    const [stepLoader, setStepLoader] = useState(true);
    const [loading, setLoading] = useState(false);


    const fetchQrData = useCallback(async () => {
        if (qrId) {
            const url = `${window.API_BASE_URL}/qrcodes/qr/${qrId}`;
            try {
                const response = await fetch(url, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                });
                const data = await response.json();
                if (response.ok) {
                    setQrData(data?.qr_code);
                }
            } catch (error) {
                console.error('Error during fetching store data:', error);
            } finally {
                setStepLoader(false);
            }
        } else {
            setStepLoader(false);
        }
    }, [qrId]);

    useEffect(() => {
        const fetchData = async () => {
            await fetchQrData();
        };
        fetchData();
    }, [fetchQrData]);


    const handleSubmit = async (values) => {
        console.log(values);
        setLoading(true);
        try {
            const response = await fetch(`${window.API_BASE_URL}/qrcodes/customer`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    customer_name : values?.name,
                    phone_no:  values?.phone_no,
                    qr_id: qrData?.qr_id,
                    user_id: qrData?.user_id
                }),
            });
            const data = await response.json();
            console.log(data);
            
            if (response.ok) {
                setSecondStapPageType('success');
            }else{
                message.error(data.message);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        stepLoader ? (
            <div className='loaderDiv'>
                <Spin
                    indicator={
                        <LoadingOutlined
                            style={{
                                fontSize: 48,
                            }}
                            spin
                        />
                    }
                />
            </div>
        ) : (
            <Row gutter={0} justify='center'>
                {Object.keys(qrData).length === 0 ? (
                    <Flex justify='center' align='center' style={{ height: '100vh', width: '100vw' }}>
                        <Result
                            status="404"
                            title="404"
                            subTitle="Sorry, the page you visited does not exist."
                        />
                    </Flex>
                ) : (
                    <Col span={8} xs={24} md={8} sm={24} lg={8} xl={8}>
                        <div className='mobile-screen'>
                            <div className='qr-landing-page'>
                                {secondStapPageType === 'landing' ? (
                                    <>
                                        <div className='main-header edit-landing-page-header' style={{ color: qrData?.text_color, backgroundColor: qrData?.theme_color, minHeight: 300 }}>
                                            <div className='background-icons' />
                                            <Title level={1} style={{ color: qrData?.text_color, marginTop: 0 }}>{qrData?.landing_page_title}</Title>
                                            <div className='store-details'>
                                                <div className='store-logo' style={{ backgroundColor: qrData?.text_color }}>
                                                    <img alt='store-logo' src={`${window.BASE_URL}${qrData?.logo ? qrData?.logo : qrData?.store_logo}`} />
                                                </div>
                                                <div className='store-profile'>
                                                    <Paragraph style={{ fontSize: 16, fontWeight: 500, color: qrData?.theme_color, margin: 0 }}>{qrData?.store_name}</Paragraph>
                                                    <div className='social-links'>
                                                        {(qrData?.phone_no) && (
                                                            <a
                                                                href={`tel:${qrData?.phone_no}`}
                                                                target='_blank'
                                                                rel="noreferrer"
                                                                className='link-logo'
                                                            >
                                                                <PiPhoneCallDuotone size={20} />
                                                            </a>
                                                        )}
                                                        {qrData?.website && (
                                                            <a
                                                                href={
                                                                    qrData?.website?.startsWith('http://') || qrData?.website?.startsWith('https://')
                                                                        ? qrData?.website
                                                                        : `http://${qrData?.website}`
                                                                }
                                                                target='_blank'
                                                                rel="noreferrer"
                                                                className='link-logo'
                                                            >
                                                                <PiGoogleChromeLogoDuotone color="red" size={20} />
                                                            </a>
                                                        )}
                                                        {qrData?.map_location && <a href={qrData?.map_location} target='_blank' rel="noreferrer" className='link-logo'><PiMapPinAreaDuotone color="green" size={20} /></a>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='user-form'>
                                            <div className='enter-details-body'>
                                                <Title level={3}>Enter your details & claim it now!</Title>
                                                <Form layout='vertical' onFinish={handleSubmit}>
                                                    <Form.Item
                                                        name='name'
                                                        rules={[{ required: true, message: 'Please enter your name!' }]}
                                                    >
                                                        <Input placeholder='Your Name' style={{height:35}} />
                                                    </Form.Item>
                                                    <Form.Item
                                                        name='phone_no'
                                                        rules={[{ required: true, message: 'Please enter your number!' }]}
                                                    >
                                                        <PhoneInput type='text' country={currencyToCountryMap[qrData?.currency_code] || 'in'} enableSearch={true} inputStyle={{ width: '100%' }} placeholder='Enter mobile number' />
                                                    </Form.Item>
                                                    <Form.Item>
                                                        <Button
                                                            type='primary'
                                                            style={{
                                                                backgroundColor: qrData?.theme_color,
                                                                color: qrData?.text_color,
                                                                width: '100%',
                                                                height: 40,
                                                                fontSize: 16,
                                                                fontWeight: 500,
                                                            }}
                                                            loading={loading}
                                                            htmlType='submit'
                                                        >
                                                            Claim your reward <PiArrowArcRightDuotone size={20} />
                                                        </Button>
                                                    </Form.Item>
                                                </Form>
                                            </div>
                                        </div>
                                    </>
                                ) : secondStapPageType === 'success' && (
                                    <>
                                        <div className='main-header edit-landing-page-header' style={{ color: qrData?.text_color, backgroundColor: qrData?.theme_color, minHeight: 300 }}>
                                            <div className='background-icons' />
                                            <PiSealCheckDuotone size={50} />
                                            <Title level={2} style={{ color: qrData?.text_color, marginTop: 0 }}>Awesome! You've claimed your reward</Title>
                                            <Paragraph style={{ color: qrData?.text_color, fontSize: 16 }}>Redeem it before it expires!</Paragraph>
                                            <Flex gap={6} align='center'>
                                                <div className='deadline-logo'>
                                                    <PiCalendarCheckDuotone size={20} />
                                                </div>
                                                <Paragraph style={{ color: qrData?.text_color, fontSize: 16, margin: 0 }}>Expires on <b>{formatDate(moment(qrData?.created_at).add(qrData?.expire_time, qrData?.expire_time_type).toDate())}</b></Paragraph>
                                            </Flex>
                                        </div>
                                        <div className='user-form'>
                                            <div className='confirmation-body'>
                                                <div className='store-details'>
                                                    <div className='store-logo' style={{ backgroundColor: qrData?.text_color }}>
                                                        <img alt='store-logo' src={`${window.BASE_URL}${qrData?.logo ? qrData?.logo : qrData?.store_logo}`} />
                                                    </div>
                                                    <div className='store-profile'>
                                                        <Paragraph style={{ fontSize: 16, fontWeight: 500, margin: 0 }}>{qrData?.store_name}</Paragraph>
                                                        <div className='social-links'>
                                                            {(qrData?.phone_no) && (
                                                                <a
                                                                    href={`tel:${qrData?.phone_no}`}
                                                                    target='_blank'
                                                                    rel="noreferrer"
                                                                    className='link-logo'
                                                                >
                                                                    <PiPhoneCallDuotone size={20} />
                                                                </a>
                                                            )}
                                                            {qrData?.website && (
                                                                <a
                                                                    href={
                                                                        qrData?.website?.startsWith('http://') || qrData?.website?.startsWith('https://')
                                                                            ? qrData?.website
                                                                            : `http://${qrData?.website}`
                                                                    }
                                                                    target='_blank'
                                                                    rel="noreferrer"
                                                                    className='link-logo'
                                                                >
                                                                    <PiGoogleChromeLogoDuotone color="red" size={20} />
                                                                </a>
                                                            )}
                                                            {qrData?.map_location && <a href={qrData?.map_location} target='_blank' rel="noreferrer" className='link-logo'><PiMapPinAreaDuotone color="green" size={20} /></a>}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className='redeem-dets'>
                                                    <div className="left">
                                                        <Paragraph className='how-to-redeem'>How to redeem?</Paragraph>
                                                        <Paragraph>Give your mobile number to the staff on your next purchase and ask them to redeem.</Paragraph>
                                                    </div>
                                                    <PiDeviceMobileSpeakerFill size={85} color='#d9d6fe' />
                                                </div>
                                                <div className='terms-and-conditions'>
                                                    <Paragraph style={{ margin: 0, fontSize: 14, fontWeight: 500 }}>Terms and Conditions</Paragraph>
                                                    {qrData.terms ? (
                                                        <ul>
                                                            {Object.keys(JSON.parse(qrData?.terms)).map((term, index) => (
                                                                <li key={index}>{term}</li>
                                                            ))}
                                                        </ul>
                                                    ) : (
                                                        <ul>
                                                            <li>1 redemption per day is allowed</li>
                                                            <li>Minimum purchase required.</li>
                                                            <li>2 offers cannot be clubbed.</li>
                                                        </ul>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </Col>
                )}
            </Row>
        )
    );
};
export default QrCodeContent;